import { LazyLoadObserve } from '@/features/shared/components/ScrollIntoView'
import dynamic from 'next/dynamic'
import { type ProductReviewStats } from '@/features/shop/services/Shelves/types'

const RatingsAndReviewSection = dynamic(
  () =>
    import('@/features/shop/components/ProductDetailRatingsAndReviews/ProductDetailRatingsAndReviews').then(
      (module) => module.ProductDetailRatingsAndReviews,
    ),
  { ssr: false },
)

interface ProductDetailRatingsAndReviewsSectionProps {
  productId: number
  reviewStats?: ProductReviewStats
  showRatingsAndReviews: boolean
}

/**
 * Renders the full ratings and reviews section at the bottom of the PDP
 * Only renders if the feature is enabled and there are ratings available
 */
export const ProductDetailRatingsAndReviewsSection = ({
  productId,
  reviewStats,
  showRatingsAndReviews,
}: ProductDetailRatingsAndReviewsSectionProps) => {
  if (!showRatingsAndReviews || !reviewStats || reviewStats.total_ratings <= 0) {
    return null
  }

  return (
    <div id="ratingsAndReviewsSection">
      <LazyLoadObserve minHeight={150}>
        <RatingsAndReviewSection productId={productId} />
      </LazyLoadObserve>
    </div>
  )
}
